import Button from "@mui/material/Button";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { useStyle } from "@/components/button/style";
import { t } from "i18next";
import { PlusIcon } from "@/icons";
import { useTheme } from "@/contexts/theme";

interface IProps {
  label: string;
  onClick: () => void;
  style?: React.CSSProperties;
  className?: string;
}
const AddButtonOld = ({ label, onClick, style, className }: IProps) => {
  const { classes } = useStyle();
  return (
    <Button
      sx={{ ...classes.addBtn, ...style }}
      startIcon={<AddBoxOutlinedIcon />}
      variant={"contained"}
      onClick={onClick}
      className={className}
    >
      {label}
    </Button>
  );
};

const AddButton = ({ label, onClick, style, className }: IProps) => {
  const { classes, primaryColor } = useStyle();
  const { currentTheme, getIconOverride } = useTheme();
  const dir: "rtl" | "ltr" = t("direction");
  const RTL = dir === "rtl";
  const isHpClient = currentTheme === "hp-client";
  const PlusIconOverride = getIconOverride("PlusIcon");

  const buttonSx = isHpClient
    ? {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: RTL ? "12px 16px 12px 20px" : "12px 20px 12px 16px",
        //padding: "16px 8px",
        gap: "8px",
        minHeight: "40px",
        height: "40px",
        minWidth: "112px",
        backgroundColor: "var(--theme-button-bg-primary)",
        color: "var(--theme-button-text-primary)",
        "&:hover": {
          backgroundColor: "var(--theme-button-bg-hover-contained)",
        },
        borderRadius: "var(--theme-button-radius)",
        textTransform: "none" as const,
        fontFamily:
          "var(--theme-typography-button-font-family, 'Forma DJR UI', sans-serif)",
        fontWeight: "var(--theme-font-weight-light, 300) !important",
        fontSize: "16px",
        lineHeight: "var(--theme-typography-label-regular-line-height, 20px)",
        boxShadow: "none",
        border: "none",
        "& .MuiButton-startIcon": {
          margin: 0,
          ...(RTL ? { marginLeft: "8px" } : { marginRight: "8px" }),
        },
        ...style,
      }
    : {
        ...classes.addButtonStyle,
        ...style,
        "& .MuiButton-startIcon": {
          ...(RTL
            ? { marginLeft: "4px", marginRight: 0 }
            : { marginRight: "4px", marginLeft: 0 }),
        },
      };

  return (
    <Button
      variant={isHpClient ? "contained" : undefined}
      sx={buttonSx}
      startIcon={
        PlusIconOverride ? (
          <PlusIconOverride />
        ) : (
          <PlusIcon stroke={primaryColor(500)} />
        )
      }
      onClick={onClick}
      className={className}
    >
      {label}
    </Button>
  );
};
export { AddButton };
